import { getAnalytics } from 'firebase/analytics';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

// 전역 변수로 auth 인스턴스 관리
let authInstance: Auth | null = null;

const initializeFirebase = (firebaseConfig: FirebaseConfig) => {
  if (!firebaseConfig) {
    throw new Error('Firebase config is required to create a Firebase instance.');
  }

  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return app;
};

const getFirebaseAuth = (firebaseConfig: FirebaseConfig) => {
  // 이미 존재하는 auth 인스턴스가 있으면 재사용
  if (authInstance) {
    return authInstance;
  }

  const app = initializeFirebase(firebaseConfig);
  authInstance = getAuth(app);

  return authInstance;
};

const getFirebaseAnalytics = (firebaseConfig: FirebaseConfig) => {
  const app = initializeFirebase(firebaseConfig);
  return getAnalytics(app);
};

export { initializeFirebase, getFirebaseAuth, getFirebaseAnalytics };
